import ReactSoundCloud from 'react-soundcloud-embedded'
const getId = (url) => {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
        return match[2];
    } else {
        return 'error';
    }
}
export const EmbedRenderer = ({ poll }) => {
    if (poll.mediaType === "yt") {
        const vidID = getId(poll.mediaLink)
        if (vidID) {
            return (
                <iframe width="100%" height="300" src={`https//www.youtube.com/embed/${vidID}`} style={{ borderRadius: 20 }} frameborder="0" allowfullscreen></iframe>
            )
        } else {
            return null
        }
    } else if (poll.mediaType === "img") {
        return (
            <img style={{ width: "100%", height: 300, objectFit: "cover", background: "#f1f1f1", borderRadius: 20 }} src={poll.mediaLink} alt="" />
        )
    } else if (poll.mediaType === "sc") {
        return (
            <ReactSoundCloud height={150} url={poll.mediaLink} />
        )
    } else if (poll.mediaType === "spot") {
        let embedURL;
        try {
            embedURL = new URL(poll.mediaLink).pathname
        } catch {
            console.log(embedURL)
        }
        return (
            <iframe wide width={"100%"} height={80} src={"https://open.spotify.com/embed" + embedURL} frameborder="0" ></iframe>
        )
    }
}